
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default  new Vuex.Store({
  state: {
    page:1,//菜单切换
    banner:1,
    tabPage:1,//每个菜单导航
    info:{},
    showSwitchMenu:false,//左边菜单浮动卡片
    childMenu:1,//二级菜单选中一级菜单高亮
    noticeIndex:0//公告角标默认0 首页每次点击关闭加1 
  },
  mutations: {
    setPage: (state, page) => {
      state.page = page
    },
    setBanner: (state, banner) => {
      state.banner = banner
    },
    setTabPage: (state, tabPage) => {
      state.tabPage = tabPage
    },
    setInfo: (state, info) => {
      state.info = info
    },
    setShowSwitchMenu: (state, showSwitchMenu) => {
      state.showSwitchMenu = showSwitchMenu
    },
    setChildMenu: (state, childMenu) => {
      state.childMenu = childMenu
    },
    setNoticeIndex: (state, noticeIndex) => {
      state.noticeIndex = noticeIndex
    },
  }
})
// export default store



// WEBPACK FOOTER //
// ./src/store/index.js